import ApplicationController from './application_controller';

export default class extends ApplicationController {
  checkRequiredFilesAndSubmit(event) {
    let filePresence = null;
    const fileFieldName = 'intake_pdf';

    const files = document.getElementsByName(fileFieldName);
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < files.length; index++) {
      const inputField = files[index];

      if (inputField.value) {
        filePresence = inputField.value;
      }
    }

    if (!filePresence) {
      alert('Please attach the intake PDF document');
      event.preventDefault();
    }
  }
}
